import { render, staticRenderFns } from "./RatingFS.vue?vue&type=template&id=568a3974&scoped=true"
import script from "./RatingFS.vue?vue&type=script&lang=js"
export * from "./RatingFS.vue?vue&type=script&lang=js"
import style0 from "./RatingFS.vue?vue&type=style&index=0&id=568a3974&prod&lang=scss&scoped=true&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "568a3974",
  null
  
)

export default component.exports